import { toast } from 'react-toastify'
import { ButtonMain } from '../../Button/ButtonMain/ButtonMain'
import { useMutation, useQueryClient } from 'react-query'
import { graphQLClient } from '~src/api/graphql'
import { ADD_PRODUCT_TO_CART } from '~src/api/product'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { getProductUrl } from '~src/util'

type TSearchProductItemProps = {
  //   product: TProduct
  product: TSearchProductItem
}

export const SearchProductItem: React.FC<TSearchProductItemProps> = ({ product }) => {
  const queryClient = useQueryClient()
  const router = useRouter()
  const highlightProductName = Array.isArray(product?.highlight?.product_name)
    ? product.highlight.product_name.join(' ')
    : product?.highlight?.product_name || ''

  const {
    isLoading: isLoadingDataAddToCart,
    mutate: mutateAddToCart,
    variables,
  } = useMutation({
    mutationFn: async (data: { data: TAddToCart[]; gotoCart: boolean }) => {
      return (await graphQLClient.request(ADD_PRODUCT_TO_CART, {
        cartId: localStorage?.getItem('cartId'),
        cartItems: data.data,
      })) as { addProductsToCart: TDataAddToCart }
    },
    onSuccess: async (
      response: { addProductsToCart: TDataAddToCart },
      variables: { data: TAddToCart[]; gotoCart: boolean }
    ) => {
      await queryClient.refetchQueries(['getCartId'])
      if (!!response?.addProductsToCart?.user_errors?.length) {
        // toast.error('Sản phẩm đã hết hàng')
        const errorMessages = response.addProductsToCart.user_errors
          .map((err: { message: string; code: string }) => err?.message)
          .join(', ')
        toast.error(errorMessages)
        return
      } else {
        if (!!variables?.gotoCart) {
          router.push('/shopping-cart')
        } else {
          queryClient.setQueryData<boolean>('miniCartVisible', true)
        }
      }
    },
  })

  const handleAddToCart = async (event: any, gotoCart?: boolean) => {
    event?.stopPropagation()

    const DATA_SUBMIT: TAddToCart[] = [
      {
        sku: product?._source?.sku || '',
        quantity: 1,
      },
    ]
    await mutateAddToCart({
      data: DATA_SUBMIT,
      gotoCart: gotoCart || false,
    })
  }

  return (
    <div className="flex gap-[1rem] p-4">
      <div className="w-[10rem] rounded-[0.8rem]">
        <Link href={getProductUrl(product?._source)}>
          <div className="pt-[100%] rounded-[0.4rem] cursor-pointer overflow-hidden relative flex-shrink-0 block">
            <img
              src={product?._source?.image}
              alt={product?._source?.product_name_website}
              className="absolute top-[0] left-[0] w-full h-full object-cover"
            />
          </div>
        </Link>
      </div>
      <div className="flex justify-between items-start w-full flex-wrap flex-col xs:flex-row gap-[1rem] ">
        <div className="flex flex-col justify-between gap-[1rem] ">
          <div className="text-[1.4rem] sm:text-[1.6rem] font-semibold line-clamp-2">
            <Link legacyBehavior href={getProductUrl(product?._source)}>
              <a>
                {highlightProductName ? (
                  <span dangerouslySetInnerHTML={{ __html: highlightProductName }} />
                ) : (
                  <span>
                    {product?._source?.product_name_website ?? product?._source?.product_name}
                  </span>
                )}
              </a>
            </Link>
          </div>

          <div className="flex gap-[0.5rem] items-center">
            <span className="text-[1.4rem] sm:text-[2rem] font-medium">
              {parseInt(product?._source?.price ?? 0, 10)?.toLocaleString()} VNĐ
            </span>
          </div>
        </div>
        <ButtonMain
          type="button"
          background="transparent"
          className="btn-trans"
          onClick={handleAddToCart}
          loading={isLoadingDataAddToCart && !variables?.gotoCart}
        >
          <span className="font-semibold">Thêm vào giỏ</span>
        </ButtonMain>
      </div>
    </div>
  )
}
